import styled from 'styled-components'

export const Container = styled.div`
  .head-visu {
    thead[class*='ant-table-thead'] th {
      background-color: yellow !important;
    }
  }
`
